<template>
	<div class="company-details">
		<site-header :userAuthenticated="true"></site-header>
		<breadcrumb>
			<router-link to="/">Home</router-link>
			<span> > </span>
			<router-link :to="'/search/' + companySearchId" v-if="companySearchId">Company Search</router-link>
			<span v-if="companySearchId"> > </span>
			<router-link :to="'/results/' + companySearchId" v-if="companySearchId">Results</router-link>
			<span v-if="companySearchId"> > </span>
			<router-link :to="'/company-details/' + companySearchId + '/' + companyId" class="active" v-if="companySearchId && dataLoaded">{{companyData.CompanyName}}</router-link>
			<router-link :to="'/company-details/' + companyId" class="active" v-if="!companySearchId && dataLoaded">{{companyData.CompanyName}}</router-link>
			<print-icon></print-icon>
			<button aria-label="Generate PDF" class="generate-pdf" @click="callGeneratePdf"><font-awesome-icon icon="file-pdf" /></button>
			<button aria-label="Generate Excel" class="generate-excel" @click="callGenerateExcel"><font-awesome-icon icon="file-excel" /></button>
		</breadcrumb>

		<main-content>
			<font-awesome-icon icon="spinner" v-if="!dataLoaded" />

			<div v-if="dataLoaded">
				<h1 class="visuallyhidden">Company Details</h1>
				<div :class="{blocked:companyData.ExcludeFromES}">
					<section class="company-information">

						<h2>Company Information</h2>
						<div>
							<dl class="group">
								<dt>Company name</dt>
								<dd>{{companyData.CompanyName}}</dd>
								<dt>Trading as</dt>
								<dd>{{companyData.TradingAsName}}</dd>
								<dt>Previous Company name</dt>
								<dd>{{companyData.PreviousCompanyName}}</dd>
								<dt>Company number</dt>
								<dd>{{companyData.RegisteredNumber}}</dd>
								<dt>Internal Reference</dt>
								<dd>{{companyData.InternalReference}}</dd>
								<dt>Client Internal Reference</dt>
								<dd>{{companyData.ClientInternalReference}}</dd>
								<dt>GUO name</dt>
								<dd>{{companyData.GUOCompanyName}}</dd>
							</dl>

							<dl class="group">
								<dt v-if="companyData.ExcludeFromES">Blocked Reason</dt>
								<dd v-if="companyData.ExcludeFromES" :class="{donotuse: companyData.ExcludeFromES}">{{companyData.ExcludeReason}}<font-awesome-icon icon="times-circle" v-if="companyData.ExcludeFromES" /></dd>
								<dt>Buyer Suppressed</dt>
								<dd>{{companyData.BuyerIsSuppressedString}}</dd>
								<dt>Globe status</dt>
								<dd :class="{donotuse: companyData.CompanyStatus.Suppressed}">{{companyData.CompanyStatus.Name}}<font-awesome-icon icon="check-circle" v-if="!companyData.CompanyStatus.Suppressed || companyData.OverwriteSuppression " /> <font-awesome-icon icon="times-circle" v-if="companyData.CompanyStatus.Suppressed  && !OverwriteSuppression" /></dd>
								<dt>Incorporated</dt>
								<dd>{{companyData.CompanyEstablishedYear}}</dd>
								<dt>Latest accounts</dt>
								<dd>{{latestAccounts}}</dd>
								<dt>Auditor name</dt>
								<dd>{{companyData.AuditorName}}</dd>
								<dt>Status</dt>
								<dd>{{companyData.CompaniesHouseStatus}}</dd>
							</dl>
						</div>

					</section>


					<section class="contact-information">
						<h2>Contact Information</h2>
						<div>
							<dl class="group">
								<dt>Trading Address</dt>
								<dd :class="{ donotuse: companyData.DoNotMail}">
									<span v-if="companyData.AddressLine1">{{companyData.AddressLine1}}<br></span>
									<span v-if="companyData.AddressLine2">{{companyData.AddressLine2}}<br></span>
									<span v-if="companyData.AddressLine3">{{companyData.AddressLine3}}<br></span>
									<span v-if="companyData.AddressLine4">{{companyData.AddressLine4}}<br></span>
									<span v-if="companyData.AddressLine5">{{companyData.AddressLine5}}<br></span>
									<span v-if="companyData.AddressTown">{{companyData.AddressTown}}<br></span>
									<span v-if="companyData.AddressCounty">{{companyData.AddressCounty}}<br></span>
									<span v-if="companyData.Postcode && companyData.Postcode">{{companyData.Postcode}}</span>
									<font-awesome-icon icon="check-circle" v-if="!companyData.DoNotMail" /> <font-awesome-icon icon="times-circle" v-if="companyData.DoNotMail" /><br>
								</dd>
								<dt>Website</dt>
								<dd><a :href="websiteUrl" target="_blank" v-if="companyData.WebsiteUrl && companyData.WebsiteUrl != '0'">{{companyData.WebsiteUrl}}</a></dd>
								<dt>Business telephone</dt>
								<dd :class="{ donotuse: companyData.DoNotUseTelephoneNumberBusiness}"><span v-if="companyData.TelephoneNumberBusiness">{{companyData.TelephoneNumberBusiness}} <font-awesome-icon icon="check-circle" v-if="!companyData.DoNotUseTelephoneNumberBusiness" /> <font-awesome-icon icon="times-circle" v-if="companyData.DoNotUseTelephoneNumberBusiness" /></span></dd>
							</dl>

							<dl class="group">
								<dt>Registered address</dt>
								<dd :class="{ donotuse: companyData.DoNotMail}">
									<span v-if="companyData.CorrespondenceAddressLine1">{{companyData.CorrespondenceAddressLine1}}<br></span>
									<span v-if="companyData.CorrespondenceAddressLine2">{{companyData.CorrespondenceAddressLine2}}<br></span>
									<span v-if="companyData.CorrespondenceAddressLine3">{{companyData.CorrespondenceAddressLine3}}<br></span>
									<span v-if="companyData.CorrespondenceAddressLine4">{{companyData.CorrespondenceAddressLine4}}<br></span>
									<span v-if="companyData.CorrespondenceAddressLine5">{{companyData.CorrespondenceAddressLine5}}<br></span>
									<span v-if="companyData.CorrespondenceAddressTown">{{companyData.CorrespondenceAddressTown}}<br></span>
									<span v-if="companyData.CorrespondenceAddressCounty">{{companyData.CorrespondenceAddressCounty}}<br></span>
									<span v-if="companyData.CorrespondencePostcode">{{companyData.CorrespondencePostcode}}</span>
									<font-awesome-icon icon="check-circle" v-if="!companyData.DoNotMail && companyData.CorrespondencePostcode" /> <font-awesome-icon icon="times-circle" v-if="companyData.DoNotMail" /><br>
								</dd>
								<dt>General email address</dt>
								<dd :class="{ donotuse: companyData.DoNotUseEmailAddress}">
									<span v-if="companyData.EmailAddress && companyData.DoNotUseEmailAddress">{{companyData.EmailAddress}}<font-awesome-icon icon="times-circle" /></span>
									<span v-if="companyData.EmailAddress && !companyData.DoNotUseEmailAddress"><a :href="'mailto:' + companyData.EmailAddress">{{companyData.EmailAddress}}</a><font-awesome-icon icon="check-circle" /></span>
								</dd>
							</dl>
						</div>
					</section>

					<section class="company-activities">
						<h2>Company Activities</h2>
						<div>
							<dl class="group">
								<dt>Sector</dt>
								<dd><span v-if="companyData.Sector">{{companyData.Sector.Name}}</span></dd>
							</dl>

							<dl class="group">
								<dt>Sub sector</dt>
								<dd><span v-if="companyData.SubSector">{{companyData.SubSector.Name}}</span></dd>
							</dl>
						</div>

						<dl class="group">
							<dt>UK SIC (2007) code(s)</dt>
							<dd><span>{{companyData.SicCode}}</span><span v-if="companyData.SicCodeData">: {{companyData.SicCodeData.Description}}</span></dd>
							<dt>Keywords</dt>
							<dd>{{keywords}}</dd>
							<dt>Acquisition Keywords</dt>
							<dd style="white-space: pre-line;">
								<p>{{companyData.AcquisitionKeywords}}</p>
							</dd>
							<dt>Business Description</dt>
							<dd style="white-space: pre-line;">
								<p>{{companyData.BusinessDescription}}</p>
							</dd>
							<dt>Business Overview</dt>
							<dd style="white-space: pre-line;">
								<p>{{companyData.BusinessOverview}}</p>
							</dd>
						</dl>
					</section>
					<section class="acquisition-history">
						<h2>Acquisition History <button aria-label="Export to Excel" class="excel-export" @click="callGenerateAcquisitionExcel" v-if="companyData.Deals && companyData.Deals.length > 0"><font-awesome-icon icon="file-excel" /></button></h2>
						<div class="table-container" v-if="companyData.Deals && companyData.Deals.length > 0">
							<table class="basic-table">
								<thead>
									<tr>
										<th>Target name</th>
										<th>Target registered number</th>
										<th>Target business description</th>
										<th>Target primary UK SIC (2007)</th>
										<th>Target country code</th>
										<th>Deal value (th GDP)</th>
										<th>Completion date</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="deal in companyData.Deals" :key="deal">
										<td>
											<router-link :to="'/company-details/' + companySearchId + '/' + deal.TargetCompany.CompanyId" v-if="companySearchId">{{deal.TargetCompany.CompanyName}}</router-link>
											<router-link :to="'/company-details/' + deal.TargetCompany.CompanyId" v-if="!companySearchId">{{deal.TargetCompany.CompanyName}}</router-link>
										</td>
										<td>{{deal.TargetCompany.RegisteredNumber}}</td>
										<td>{{deal.TargetCompany.BusinessDescription}}</td>
										<td>{{deal.TargetPrimarySIC}}</td>
										<td>{{deal.TargetCountryCode}}</td>
										<td><span v-if="deal.DealValue">&pound;{{ addCommasToNumber(deal.DealValue) }}</span></td>
										<td v-text="formatDate(deal.CompletedDate)"></td>
									</tr>
								</tbody>
							</table>
						</div>
						<p>
							NDA on file?
							<strong v-if="companyData.BuyerTraitSignedNDA">Yes</strong>
							<strong v-if="!companyData.BuyerTraitSignedNDA">No</strong>
						</p>
						<p>
							Deals on File?
							<strong v-if="companyData.Deals.length > 0">Yes</strong>
							<strong v-if="companyData.Deals.length == 0">No</strong>
						</p>
					</section>

					<section class="financial-information" v-if="companyData.CompanyFinancials && companyData.CompanyFinancials.length > 0">
						<h2>Key Financial Information <button aria-label="Export to Excel" class="excel-export" @click="callGenerateFinancialExcel"><font-awesome-icon icon="file-excel" /></button></h2>

						<div class="table-container">
							<table class="basic-table">
								<thead>
									<tr>
										<th></th>
										<th v-if="financialData[0]"><span v-if="financialData[0].IsProjection">Projection<br></span>{{financialData[0].Month}}/{{financialData[0].Year}}</th>
										<th v-if="financialData[1]"><span v-if="financialData[1].IsProjection">Projection<br></span>{{financialData[1].Month}}/{{financialData[1].Year}}</th>
										<th v-if="financialData[2]"><span v-if="financialData[2].IsProjection">Projection<br></span>{{financialData[2].Month}}/{{financialData[2].Year}}</th>
										<th v-if="financialData[3]"><span v-if="financialData[3].IsProjection">Projection<br></span>{{financialData[3].Month}}/{{financialData[3].Year}}</th>
										<th v-if="financialData[4]"><span v-if="financialData[4].IsProjection">Projection<br></span>{{financialData[4].Month}}/{{financialData[4].Year}}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Turnover</td>
										<td v-if="financialData[0]"><span v-if="financialData[0].Turnover">&pound;{{ addCommasToNumber(financialData[0].Turnover) }}</span></td>
										<td v-if="financialData[1]"><span v-if="financialData[1].Turnover">&pound;{{ addCommasToNumber(financialData[1].Turnover) }}</span></td>
										<td v-if="financialData[2]"><span v-if="financialData[2].Turnover">&pound;{{ addCommasToNumber(financialData[2].Turnover) }}</span></td>
										<td v-if="financialData[3]"><span v-if="financialData[3].Turnover">&pound;{{ addCommasToNumber(financialData[3].Turnover) }}</span></td>
										<td v-if="financialData[4]"><span v-if="financialData[4].Turnover">&pound;{{ addCommasToNumber(financialData[4].Turnover) }}</span></td>
									</tr>
									<tr>
										<td>Gross Profit</td>
										<td v-if="financialData[0]"><span v-if="financialData[0].GrossProfit">&pound;{{ addCommasToNumber(financialData[0].GrossProfit) }}</span></td>
										<td v-if="financialData[1]"><span v-if="financialData[1].GrossProfit">&pound;{{ addCommasToNumber(financialData[1].GrossProfit) }}</span></td>
										<td v-if="financialData[2]"><span v-if="financialData[2].GrossProfit">&pound;{{ addCommasToNumber(financialData[2].GrossProfit) }}</span></td>
										<td v-if="financialData[3]"><span v-if="financialData[3].GrossProfit">&pound;{{ addCommasToNumber(financialData[3].GrossProfit) }}</span></td>
										<td v-if="financialData[4]"><span v-if="financialData[4].GrossProfit">&pound;{{ addCommasToNumber(financialData[4].GrossProfit) }}</span></td>
									</tr>
									<tr>
										<td>EBIT</td>
										<td v-if="financialData[0]"><span v-if="financialData[0].Ebit">&pound;{{ addCommasToNumber(financialData[0].Ebit) }}</span></td>
										<td v-if="financialData[1]"><span v-if="financialData[1].Ebit">&pound;{{ addCommasToNumber(financialData[1].Ebit) }}</span></td>
										<td v-if="financialData[2]"><span v-if="financialData[2].Ebit">&pound;{{ addCommasToNumber(financialData[2].Ebit) }}</span></td>
										<td v-if="financialData[3]"><span v-if="financialData[3].Ebit">&pound;{{ addCommasToNumber(financialData[3].Ebit) }}</span></td>
										<td v-if="financialData[4]"><span v-if="financialData[4].Ebit">&pound;{{ addCommasToNumber(financialData[4].Ebit) }}</span></td>
									</tr>
									<tr>
										<td>EBITDA</td>
										<td v-if="financialData[0]"><span v-if="financialData[0].Ebitda">&pound;{{ addCommasToNumber(financialData[0].Ebitda) }}</span></td>
										<td v-if="financialData[1]"><span v-if="financialData[1].Ebitda">&pound;{{ addCommasToNumber(financialData[1].Ebitda) }}</span></td>
										<td v-if="financialData[2]"><span v-if="financialData[2].Ebitda">&pound;{{ addCommasToNumber(financialData[2].Ebitda) }}</span></td>
										<td v-if="financialData[3]"><span v-if="financialData[3].Ebitda">&pound;{{ addCommasToNumber(financialData[3].Ebitda) }}</span></td>
										<td v-if="financialData[4]"><span v-if="financialData[4].Ebitda">&pound;{{ addCommasToNumber(financialData[4].Ebitda) }}</span></td>
									</tr>
									<tr>
										<td>Shareholders Funds</td>
										<td v-if="financialData[0]"><span v-if="financialData[0].ShareholderFunds">&pound;{{ addCommasToNumber(financialData[0].ShareholderFunds) }}</span></td>
										<td v-if="financialData[1]"><span v-if="financialData[1].ShareholderFunds">&pound;{{ addCommasToNumber(financialData[1].ShareholderFunds) }}</span></td>
										<td v-if="financialData[2]"><span v-if="financialData[2].ShareholderFunds">&pound;{{ addCommasToNumber(financialData[2].ShareholderFunds) }}</span></td>
										<td v-if="financialData[3]"><span v-if="financialData[3].ShareholderFunds">&pound;{{ addCommasToNumber(financialData[3].ShareholderFunds) }}</span></td>
										<td v-if="financialData[4]"><span v-if="financialData[4].ShareholderFunds">&pound;{{ addCommasToNumber(financialData[4].ShareholderFunds) }}</span></td>
									</tr>
									<tr>
										<td>Cash</td>
										<td v-if="financialData[0]"><span v-if="financialData[0].BankDeposits">&pound;{{ addCommasToNumber(financialData[0].BankDeposits) }}</span></td>
										<td v-if="financialData[1]"><span v-if="financialData[1].BankDeposits">&pound;{{ addCommasToNumber(financialData[1].BankDeposits) }}</span></td>
										<td v-if="financialData[2]"><span v-if="financialData[2].BankDeposits">&pound;{{ addCommasToNumber(financialData[2].BankDeposits) }}</span></td>
										<td v-if="financialData[3]"><span v-if="financialData[3].BankDeposits">&pound;{{ addCommasToNumber(financialData[3].BankDeposits) }}</span></td>
										<td v-if="financialData[4]"><span v-if="financialData[4].BankDeposits">&pound;{{ addCommasToNumber(financialData[4].BankDeposits) }}</span></td>
									</tr>
									<tr>
										<td>No. of Employees</td>
										<td v-if="financialData[0]"><span v-if="financialData[0].NumberOfEmployees">{{ financialData[0].NumberOfEmployees }}</span></td>
										<td v-if="financialData[1]"><span v-if="financialData[1].NumberOfEmployees">{{ financialData[1].NumberOfEmployees }}</span></td>
										<td v-if="financialData[2]"><span v-if="financialData[2].NumberOfEmployees">{{ financialData[2].NumberOfEmployees }}</span></td>
										<td v-if="financialData[3]"><span v-if="financialData[3].NumberOfEmployees">{{ financialData[3].NumberOfEmployees }}</span></td>
										<td v-if="financialData[4]"><span v-if="financialData[4].NumberOfEmployees">{{ financialData[4].NumberOfEmployees }}</span></td>
									</tr>
								</tbody>
							</table>
						</div>
					</section>

					<section class="contacts" v-if="companyData.CompanyVendors && companyData.CompanyVendors.length > 0">
						<h2>Contacts</h2>

						<div v-for="vendor in companyData.CompanyVendors" :key="vendor">
							<dl class="group">
								<dt>Full name</dt>
								<dd><strong>{{vendor.Fullname}}</strong></dd>
								<dt>Current role</dt>
								<dd>{{vendor.Role.Name}}</dd>
								<dt>Primary telephone</dt>
								<dd>
									<span v-if="vendor.TelephoneBusiness" :class="{ donotuse: vendor.DoNotUseTelephoneBusiness}">{{vendor.TelephoneBusiness}} <font-awesome-icon icon="check-circle" v-if="!vendor.DoNotUseTelephoneBusiness" /> <font-awesome-icon icon="times-circle" v-if="vendor.DoNotUseTelephoneBusiness" /></span>
									<span v-if="vendor.TelephoneBusiness && vendor.TelephoneMobile"> / </span>
									<span v-if="vendor.TelephoneMobile" :class="{ donotuse: vendor.DoNotUseTelephoneMobile}">{{vendor.TelephoneMobile}} <font-awesome-icon icon="check-circle" v-if="!vendor.DoNotUseTelephoneMobile" /> <font-awesome-icon icon="times-circle" v-if="vendor.DoNotUseTelephoneMobile" /></span>
								</dd>
								<dt>Alternative telephone</dt>
								<dd><span v-if="vendor.TelephoneAlternative" :class="{ donotuse: vendor.DoNotUseTelephoneAlternative}">{{vendor.TelephoneAlternative}} <font-awesome-icon icon="check-circle" v-if="!vendor.DoNotUseTelephoneAlternative" /> <font-awesome-icon icon="times-circle" v-if="vendor.DoNotUseTelephoneAlternative" /></span></dd>
								<dt>Primary email</dt>
								<dd>
									<span v-if="vendor.EmailAddress && vendor.DoNotUseEmailAddress" class="donotuse">{{vendor.EmailAddress}}<font-awesome-icon icon="times-circle" /></span>
									<span v-if="vendor.EmailAddress && !vendor.DoNotUseEmailAddress"><a :href="'mailto:' + vendor.EmailAddress">{{vendor.EmailAddress}}</a> <font-awesome-icon icon="check-circle" /></span>
								</dd>
								<dt>Alternative email</dt>
								<dd>
									<span v-if="vendor.EmailAddressAlternative && vendor.DoNotUseEmailAddressAlternative" class="donotuse">{{vendor.EmailAddressAlternative}}<font-awesome-icon icon="times-circle" /></span>
									<span v-if="vendor.EmailAddressAlternative && !vendor.DoNotUseEmailAddressAlternative"><a :href="'mailto:' + vendor.EmailAddressAlternative">{{vendor.EmailAddressAlternative}}</a> <font-awesome-icon icon="check-circle" /></span>
								</dd>
							</dl>

							<dl class="group">
								<dt>Shareholding (%)</dt>
								<dd><strong v-if="vendor.Shareholding">{{vendor.Shareholding}}%</strong></dd>
								<dt>Correspondence address</dt>
								<dd>
									<span v-if="vendor.CorrespondenceAddressLine1">{{vendor.CorrespondenceAddressLine1}}<br></span>
									<span v-if="vendor.CorrespondenceAddressLine2">{{vendor.CorrespondenceAddressLine2}}<br></span>
									<span v-if="vendor.CorrespondenceAddressLine3">{{vendor.CorrespondenceAddressLine3}}<br></span>
									<span v-if="vendor.CorrespondenceAddressLine4">{{vendor.CorrespondenceAddressLine4}}<br></span>
									<span v-if="vendor.CorrespondencePostcode">{{vendor.CorrespondencePostcode}}</span>
								</dd>
							</dl>
						</div>

					</section>

					<section class="group-companies" v-if="companyGroup && companyGroup.Companies && companyGroup.Companies.length > 0">
						<h2>Group Companies</h2>

						<div class="table-container">
							<table class="basic-table">
								<thead>
									<tr>
										<th>Company Name</th>
										<th>Registered number</th>
										<th>Company Level</th>
									</tr>
								</thead>
								<tbody>

									<tr v-for="company in companyGroup.Companies" :key="company">
										<td>
											<a :href="'/#/company-details/' + companySearchId + '/' + company.CompanyId" target="_blank" v-if="companySearchId">{{company.CompanyName}}</a>
											<a :href="'/#/company-details/' + company.CompanyId" target="_blank" v-if="!companySearchId">{{company.CompanyName}}</a>
										</td>
										<td>{{company.RegisteredNumber}}</td>
										<td v-if="company.CompanyHierarchy">{{company.CompanyHierarchy.Name}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</section>
				</div>
			</div>
		</main-content>
	</div>
</template>

<script>
import SiteHeader from '../components/header/SiteHeader'
import PrintIcon from '../components/other/PrintIcon'
import Breadcrumb from '../components/reusable/Breadcrumb'
import MainContent from '../components/reusable/MainContent'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import { mapState, mapActions } from 'vuex'
import { isSet, blob2file } from '../helpers/helpers'
import _ from 'lodash'
import moment from 'moment'

	export default {
		name: 'CompanyDetails',
		data() {
			return {

			}
		},
		components: {
			SiteHeader,
			Breadcrumb,
			MainContent,
			PrintIcon,
			FontAwesomeIcon
		},
		created() {
			this.loadData();
		},
		computed: {
			...mapState({
				companyData: state => state.companymodule.companyData,
				companyGroup: state => state.companymodule.companyGroup,
				dataLoaded: state => state.companymodule.dataLoaded
			}),
			financialData() {
				let financialData = this.companyData.CompanyFinancials;

				if (isSet(financialData) && financialData.length > 0) {
					financialData = _.sortBy(financialData, 'Year').reverse();

					_(financialData).forEach((element) => {
						let month = element.Month;
						if (month.toString().length == 1) element.Month = '0' + month;
					});

					return financialData;
				}
				else {
					return '';
				}
			},
			latestAccounts() {
				let financialData = this.financialData;
				if (isSet(financialData) && financialData.length > 0) return financialData[0].Month + '/' + financialData[0].Year;
				return '';
			},
			websiteUrl() {
				let url = this.companyData.WebsiteUrl;

				if (isSet(url)) {
					if (url.indexOf('http') > -1) return url;
					else return 'http://' + url;
				}else return "";
			},
			keywords() {
				if (this.companyData.CompanyKeywords != null && this.companyData.CompanyKeywords.length > 0) {
					let keywords = this.companyData.CompanyKeywords[0].Keyword.toString();
					return keywords.replace(/ \u2022 /g, ', ').replace(/\u2022/g, '');
				}
				else {
					return '';
				}
			}
		},
		methods: {
			...mapActions('exportmodule', [
				'generatePDF',
				'generateExcel',
				'generateFinancialExcel',
				'generateAcquisitionExcel'
			]),
			loadData() {
				this.$store.dispatch('companymodule/getCompany', this.companyId);
				this.$store.dispatch('companymodule/getCompanyGroup', this.companyId);
			},
			callGeneratePdf() {
				this.generatePDF(this.companyId).then(response => {
					let fileName = response.fileName;
					let hash = response.hash;
					this.$store.dispatch('filemodule/getFile', [fileName, hash]).then(response => {							
						blob2file(response.data, fileName);		
					});
				});
			},
			formatDate(date) {
				let formattedDate = moment(date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY');
				if (formattedDate === 'Invalid date') return '';
				else return formattedDate;
			},
			callGenerateExcel() {
				this.generateExcel(this.companyId).then(response => {
					let fileName = response.fileName;
					let hash = response.hash;
					this.$store.dispatch('filemodule/getFile', [fileName, hash]).then(response => {							
						blob2file(response.data, fileName);		
					});
				});
			},
			callGenerateFinancialExcel() {
				this.generateFinancialExcel(this.companyId).then(response => {
					let fileName = response.fileName;
					let hash = response.hash;
					this.$store.dispatch('filemodule/getFile', [fileName, hash]).then(response => {							
						blob2file(response.data, fileName);		
					});
				});
			},
			callGenerateAcquisitionExcel() {
				this.generateAcquisitionExcel(this.companyId).then(response => {
					let fileName = response.fileName;
					let hash = response.hash;
					this.$store.dispatch('filemodule/getFile', [fileName, hash]).then(response => {							
						blob2file(response.data, fileName);		
					});
				});
			},
			addCommasToNumber(number) {
				return number.toLocaleString('en', { useGrouping: true });
			}
		},
		watch: {
      // eslint-disable-next-line no-unused-vars
			companyId (newVal, oldVal) {
				this.loadData();
			}
		},
		props: ['companyId', 'companySearchId']
	}
</script>

<style lang="scss" scoped>
	.company-details {
		padding-bottom: 40px;
	}

	.main-content {
		margin: 30px;
	}

	dt {
		font-weight: bold;
	}

	.company-information, .contacts, .contact-information {
		margin-bottom: 30px;

		>div {
			display: flex;
		}
		dl {
			flex-grow: 1;
			padding-right: 40px;
		}
		dt {
			float: left;
			min-width: 200px;
			clear: both;
			margin-bottom: 3px;
		}
		dd {
			float: left;
			margin-bottom: 20px;
			min-height:18px;
		}
		@media only screen and (max-width: 800px) {
			>div {
				display: block;
			}
		}
		@media only screen and (max-width: 1300px) {
			dl{
				margin-top:0;
				margin-bottom:0;
			}

			dd,
			dt {
				float: none;
				margin-left: 0;
			}
		}
		svg {
			margin-left: 10px;
		}
		svg.fa-check-circle {
			color: #3fa71e;
		}
		svg.fa-times-circle {
			color: #d43131;
		}
	}

	.contacts{
		> div{
			border-bottom:1px solid #e4e4e4;
		}

		> div:first-of-type dl{
			margin-top:0;
		}

		dl{
			margin-top:40px;
			margin-bottom:20px;
		}

		> div:last-of-type{
			border-bottom:0;
		}

		svg{
			margin-left:10px;
		}

		svg.fa-check-circle{
			color:#3fa71e;
		}

		svg.fa-times-circle{
			color:#d43131;
		}

		@media only screen and (max-width: 800px) {
			dl {
				margin-bottom:0;
				margin-top:20px;
			}

			dl:last-of-type {
				margin-top:0;
			}
		}
	}

	.company-activities {
		>div {
			display: flex;
			dl {
				flex-grow: 1;
				padding-right: 40px;
			}
			dt {
				float: left;
				min-width: 200px;
				clear: both;
			}
		}
		dl:nth-child(3) {
			dt,
			dd {
				float: left;
			}
			dt {
				width: 20%;
				clear: both;
				margin-bottom: 20px;
			}
			dd {
				width: 70%;
				margin-left: 5%;
				margin-right: 5%;
				margin-bottom: 20px;
			}
		}
		p {
			margin-top: 0;
		}
		@media only screen and (min-width: 1700px) {
			>div {
				max-width: 70%;
			}
		}
		@media only screen and (max-width: 1100px) {
			>div {
				display: block;
			}
			dl dd,
			dt {
				width: auto !important;
				float: none !important;
				margin-left: 0 !important;
			}
		}
	}

	.acquisition-history, .financial-information, .group-companies{
		margin-bottom:30px;

		.table-container {
			overflow: auto;
			table {
				width: 100%;

				th:first-child {
					min-width: 80px;
				}

				th,
				td {
					padding: 10px;
					font-weight: normal;
				}

				thead {
					background: #a8e6ff;
				}

				tr:nth-child(even) {
					background: #fbfbfb;
				}
			}
		}

		.excel-export{
			background:none;
			border:0;

			svg{
				color:#3fa71e;
			}
		}
	}

	.contacts{
		margin-bottom:30px;
	}

	.group-companies{
		margin-bottom:0;

		tbody tr:nth-of-type(1) td{
			font-weight:bold;
		}
	}

	.generate-pdf, .generate-excel{
		background:none;
		border:0;
		position: absolute;
		top: 8px;

		svg{
			width:20px;
			height:20px;
		}
	}

	.generate-pdf{
		right: 60px;
		color:#d43131;
	}

	.generate-excel{
		right: 92px;
		color:#3fa71e;
	}

	.todo{
		color:red !important;
	}

	.donotuse {
		color: #d43131;
	}
    .blocked {
        border: solid;
        border-color: red;
    }
</style>
